import {CommandActionInterface, CommandActionBase} from '../command-action';
import {Document} from "../../../providers/global.service";
import {filter} from "rxjs/operators";
import {GlobalServiceProvider} from "../../../providers/global.service";
import {Component, Inject, NgModule} from "@angular/core";



export class DocumentListCmdAction extends CommandActionBase implements CommandActionInterface{

  componentName:string;
  commandString:string;
  global:GlobalServiceProvider;

  public documentObservable;
  public documents:Array<Document> = [];

  constructor(){
    super();
  }

  do(commandString?){
    this.commandString = commandString;

    return new Promise( (resolve, reject)=>{
      this.documentObservable = this.global.getDocumentObservable();

      this.documentObservable
        .pipe(filter( (p:any) => {

          let isNew = true;
          this.documents.forEach(myDocument => {
            if (myDocument.name === p.name) isNew = false;
          });
          return isNew;
        })).subscribe((document: Document) => {
        this.documents.push(document);
      });

      this.global.fetchDocuments();
      resolve({commandString: this.commandString, commandAction: this});
    });


  }

  getResult(){
    return this.documents
  }

  destroy() {
    this.documentObservable.unsubscribe();
  }


  public static getNew(){
    return new DocumentListCmdAction();
  }

}



// WEBPACK FOOTER //
// ./src/components/commands/document-list-cmd/document-list-cmd-action.ts